import { apiProxyRequest } from "Api/apiProxyRequest";

type DeleteApiTokenRequestProps = { userId: string; tokenId: string };

export const deleteApiTokenRequest = ({
  userId,
  tokenId
}: DeleteApiTokenRequestProps) =>
  apiProxyRequest<undefined>(
    `/users/${userId}/api-tokens/${tokenId}`,
    "DELETE"
  );
